
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { inventarioXBodega, inventarioXBodegaSinPaginar, startStockXID } from "../../../services";





export const useStockXID = (id) => {

    const stockXIDQuery = useQuery({
        queryKey: ['stock-id', id], 
        queryFn: () => startStockXID(id),
    });

    return { stockXIDQuery }
}





export const useInventarioXBodega = (id) => {

    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const inventarioXBodegaQuery = useQuery({
        queryKey: ['inventario-xbodega', { page, termino, id }], 
        queryFn: () => inventarioXBodega({ page, termino, id }),
    });


    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    return {
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        inventarioXBodegaQuery,
    }
}





export const useInventarioSinPaginarXBodega = (id) => {

    const inventarioSinPaginar = useQuery({
        queryKey: ['inventario-sinpaginar', id], 
        queryFn: () => inventarioXBodegaSinPaginar(id),
    });

    return { inventarioSinPaginar }
}




